import { ActionButton } from "./ActionButton"
import { ActionDropdownButton } from "./ActionDropdownButton"
import { ActionLink } from "./ActionLink"
import { ActionTOULink } from "./ActionTOULink"
import { ActionType } from "../../../base/types"
import { ActionUMSLink } from "./ActionUMSLink"
import { FC } from "react"
import { IPageAction } from "../../../base/models"
import { PortalLink } from "./PortalLink"
import { HyperLink } from "./HyperLink"

interface IActionToolbarItemProps {
    action: IPageAction
}

export const ActionToolbarItem: FC<IActionToolbarItemProps> = ({
    action
}) => {
    switch (action.type) {
        case ActionType.Action:
            return <ActionButton action={action} />
        case ActionType.ActionLink:
            return <ActionLink action={action} />
        case ActionType.TOULink:
            return <ActionTOULink action={action} />
        case ActionType.UMSLink:
            return <ActionUMSLink action={action} />
        case ActionType.PortalLink:
            return <PortalLink action={action} />
        case ActionType.HyperLink:
            return <HyperLink action={action} />
        case ActionType.ActionGroup:
            return <ActionDropdownButton action={action} />
    }
}

